import * as React from 'react';

function SvgPlus(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15 6a.73.73 0 00-.73.73l-.006 7.534-7.535.006a.73.73 0 10.001 1.46l7.547-.007-.006 7.547a.73.73 0 001.459 0v-7.54h7.541a.73.73 0 10-.001-1.46l-7.547.007.007-7.547A.73.73 0 0015 6z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgPlus;
